<template>
  <div class="page">
    <div class="main_box">
      <img class="logo" src="../assets/img/ic_88_支付宝@3x.png" alt="支付宝logo" />
      <div class="ttl">支付宝</div>
      <div class="desc">您需要打开支付宝办理网上银行卡</div>
      <span class="btn" @click="guideVisible = true" v-if="isWX">打开支付宝办卡</span>
      <a :href="url" class="btn" v-else>打开支付宝办卡</a>
      <div class="remark">
        无法打开时，可使用默认浏览器打开。<span class="b" @click="copy">复制链接</span>
      </div>
    </div>
    <div class="mask" @click="guideVisible = false" v-if="guideVisible">
      <img class="guide" src="../assets/img/引导弹窗@3x.png" alt="浏览器打开" />
    </div>
    <Toast v-if="toast.status" @close="onToastClose">{{ toast.title }}</Toast>
  </div>
</template>

<script>
import Toast from '../components/Toast.vue';

function copyText(text) {
  if (window.navigator && window.navigator.clipboard && window.navigator.clipboard.writeText) {
    window.navigator.clipboard.writeText(text);
    return;
  }
  const textareaC = document.createElement('textarea');
  textareaC.setAttribute('readonly', 'readonly'); // 设置只读属性防止手机上弹出软键盘
  textareaC.value = text;
  document.body.appendChild(textareaC); // 将textarea添加为body子元素
  textareaC.select();
  document.execCommand('copy');
  document.body.removeChild(textareaC); // 移除DOM元素
}

export default {
  data() {
    return {
      toast: {
        status: false,
        title: '',
      },
      url: 'https://ur.alipay.com/5bUKBawi1N98a33uXgBjLx',
      isWX: false,
      guideVisible: false,
    };
  },
  components: { Toast },
  mounted() {
    this.initEnv();
  },
  methods: {
    initEnv() {
      const { url } = this;
      setTimeout(() => {
        const isWX = !!window.WeixinJSBridge;
        if (!isWX) {
          window.location.href = url;
        }
        this.isWX = isWX;
      }, 1000);
    },
    /**
     * toast
     */
    showToast(opt = {}) {
      this.toast.status = true;
      this.toast.title = opt.title;
    },
    /**
     * toast关闭
     */
    onToastClose() {
      this.toast.status = false;
      this.toast.title = '';
    },
    copy() {
      copyText(window.location.href);
      this.showToast({
        title: '复制成功',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main_box {
  margin-top: -2rem;
}

.logo {
  display: block;
  width: 4.4rem;
  height: 4.4rem;
  margin: auto;
}

.ttl {
  margin-top: 0.8rem;
  font-weight: 600;
  font-size: 1rem;
  color: #1A202A;
  text-align: center;
  line-height: 1.5rem;
}

.desc {
  margin-top: 0.2rem;
  font-weight: 400;
  font-size: 0.75rem;
  color: #7F8388;
  text-align: center;
  line-height: 1.1rem;
}

.btn {
  display: block;
  width: 15.55rem;
  height: 2.4rem;
  margin: 4.4rem auto 0;
  background: #3C82F8;
  border-radius: 0.6rem;
  font-weight: 600;
  font-size: 0.85rem;
  color: #fff;
  text-align: center;
  line-height: 2.4rem;
  text-decoration: none;
}

.remark {
  margin-top: 0.8rem;
  font-weight: 400;
  font-size: 0.65rem;
  color: #A4A6AA;
  text-align: center;
  line-height: 1rem;
}

.remark .b {
  color: #3C82F8;
  text-decoration: underline;
}

.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .3);

  .guide {
    margin-left: 5.25rem;
    width: 12.5rem;
    height: 6rem;
  }
}
</style>
